"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("@prosay/common");
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
/* eslint-disable @typescript-eslint/no-explicit-any */
const useInvertedScrollingWeb = (ref) => react_1.useEffect(() => {
    var _a;
    common_1.assert(ref.current);
    const scrollNode = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getScrollableNode();
    const wheel = (event) => {
        scrollNode.scrollTop += event.wheelDeltaY || -event.deltaY;
        event.preventDefault();
    };
    scrollNode.addEventListener("wheel", wheel);
    return () => {
        scrollNode.removeEventListener("wheel", wheel);
    };
}, [ref]);
const useInvertedScrollingMobileWeb = (ref) => react_1.useEffect(() => {
    var _a;
    common_1.assert(ref.current);
    const scrollNode = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getScrollableNode();
    let state;
    const touchStart = (event) => {
        // eslint-disable-next-line prefer-destructuring
        state = event.touches[0];
        event.preventDefault();
    };
    const touchMove = (event) => {
        if (state) {
            scrollNode.scrollTop +=
                event.changedTouches[0].screenY - state.screenY;
        }
        // eslint-disable-next-line prefer-destructuring
        state = event.touches[0];
        event.preventDefault();
    };
    const touchEnd = (event) => {
        if (state) {
            state = undefined;
        }
        event.preventDefault();
    };
    scrollNode.addEventListener("touchstart", touchStart);
    scrollNode.addEventListener("touchmove", touchMove);
    scrollNode.addEventListener("touchend", touchEnd);
    return () => {
        scrollNode.removeEventListener("touchstart", touchStart);
        scrollNode.removeEventListener("touchmove", touchMove);
        scrollNode.removeEventListener("touchend", touchEnd);
    };
}, [ref]);
// TODO: Do we need to do this only on web?
// Implementation taken from https://github.com/necolas/react-native-web/pull/1137/files
function InvertedFlatList(props) {
    const ref = react_1.useRef(null);
    useInvertedScrollingWeb(ref);
    useInvertedScrollingMobileWeb(ref);
    return react_1.default.createElement(react_native_1.FlatList, Object.assign({ inverted: true }, { ref, ...props }));
}
exports.InvertedFlatList = InvertedFlatList;
//# sourceMappingURL=data:application/json;base64,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